<template>
    <x-label :color="color" :title="title">
        <i class="fa fa-magic" /> {{ label }}
    </x-label>
</template>

<script>
import XLabel from './XLabel.vue'
export default {
    components: { XLabel },
    props: {
        color: {
            type: String,
            required: false,
            default: 'success',
        },
        label: {
            type: String,
            required: false,
            default: 'Trigger',
        },
        title: {
            type: String,
            required: false,
            default: 'Trigger aktif',
        },
    },
}
</script>